module.exports = __webpack_public_path__ + "static/media/ppe.6416816e.svg";